import React from "react";

export default function ErrorRetry({ message, onRetry }) {
  return (
    <div className="error error-retry">
      <span>{message}</span>
      {onRetry && (
        <button type="button" className="btn btn-sm" onClick={onRetry}>
          Повторить
        </button>
      )}
    </div>
  );
}
